import React, { useEffect, useRef } from 'react';
import { Map as VisGlMap, useMap } from '@vis.gl/react-google-maps';
const DEFAULT_OPTIONS = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: true,
    fullscreenControl: false,
};
const ApplyOptions = ({ options, }) => {
    const map = useMap();
    useEffect(() => {
        if (!map)
            return;
        map.setOptions(options);
    }, [map, options]);
    return null;
};
const FitBounds = ({ points }) => {
    const map = useMap();
    useEffect(() => {
        if (!map || points.length === 0)
            return;
        const bounds = new google.maps.LatLngBounds();
        points.forEach((p) => bounds.extend(p));
        map.fitBounds(bounds);
    }, [map, points]);
    return null;
};
const ClickHandler = ({ onClick }) => {
    const map = useMap();
    useEffect(() => {
        if (!map)
            return undefined;
        const listener = map.addListener('click', onClick);
        return () => listener.remove();
    }, [map, onClick]);
    return null;
};
const MapReady = ({ onMapReady, }) => {
    const map = useMap();
    const calledRef = useRef(false);
    useEffect(() => {
        if (map && !calledRef.current) {
            calledRef.current = true;
            onMapReady(map);
        }
    }, [map, onMapReady]);
    return null;
};
export const Map = ({ className, style, height, width, center, defaultCenter, zoom, defaultZoom, options, fitBoundsTo, onClick, onMapReady, mapId, children, }) => {
    var _a;
    const mergedOptions = Object.assign(Object.assign({}, DEFAULT_OPTIONS), (options || {}));
    const wrapperStyle = Object.assign(Object.assign(Object.assign({}, (width !== undefined ? { width } : {})), (height !== undefined ? { height } : {})), (style || {}));
    return (React.createElement("div", { className: className, style: wrapperStyle },
        React.createElement(VisGlMap, { mapId: mapId, defaultCenter: defaultCenter || center || { lat: 0, lng: 0 }, center: center, defaultZoom: (_a = defaultZoom !== null && defaultZoom !== void 0 ? defaultZoom : zoom) !== null && _a !== void 0 ? _a : 10, zoom: zoom, gestureHandling: "greedy", clickableIcons: false },
            React.createElement(ApplyOptions, { options: mergedOptions }),
            onClick && React.createElement(ClickHandler, { onClick: onClick }),
            fitBoundsTo && fitBoundsTo.length > 0 && (React.createElement(FitBounds, { points: fitBoundsTo })),
            onMapReady && React.createElement(MapReady, { onMapReady: onMapReady }),
            children)));
};
